// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {useStore} from '@nanostores/react';
import {$user} from '../../store/user.js';
import store from '../../store.js';
import {get_referral_link} from '../../utils/path.js';
import {REFERRAL_BASE, REFERRAL_BASE_BVPN, FAQ_LINK_REFERRAL,
    FAQ_LINK_BVPN_REF_RATES,
    FAQ_LINK_BVPN_REFERRAL} from '../../utils/constants.js';
import {Text} from '../text';
import {Copy_row} from '../copy_row';
import * as cns from './invite_sharer.module.less';

function FAQ_link({link}){
    return <a className={cn(cns.link, cns.link__help)} href={link}
      target="_blank" rel="noreferrer noopener">
      <Text.xxs span className={cns.link_text}>How does it work?</Text.xxs>
    </a>;
}

function BVPN_ref_msg(){
  return <div>
    <Text.s className={cns.notice}>
      Contact <b>Admin Vita (@brightvita)</b> on our &nbsp;
      <a href="https://discord.gg/8vM3eauVrM">Discord Server</a>{' '}
      for verification and to obtain your <b>BrightVPN</b> referral link
    </Text.s>
  </div>;
}

function Link_bvpn({code, show_ref}){
    return <div className={cns.wrapper}>
      <div className={cns.label}>
        <Text.s span secondary>Personal Bright VPN referral link</Text.s>{' '}
        <a className={cns.link} href={FAQ_LINK_BVPN_REF_RATES} target="_blank"
          rel="noreferrer noopener">
          <Text.xs span secondary className="eais_help_label">
            - earn for each referral!
          </Text.xs>
        </a>
      </div>
      {show_ref && <Copy_row className={cns.link}
        value={get_referral_link(REFERRAL_BASE_BVPN, code)}/>}
      {!show_ref && <BVPN_ref_msg/>}
      <FAQ_link link={FAQ_LINK_BVPN_REFERRAL}/>
    </div>;
}

function Link({code, part}){
    return <div className={cns.wrapper}>
      <div className={cns.label}>
        <Text.s span secondary>
          Personal EarnApp referral link - earn
        </Text.s>
        {' '}
        <Text.xs span>
          <Text.xs span mono bold className="eais_part">{part}</Text.xs>{' '}
          <Text.xs span secondary>of referral earnings!</Text.xs>
        </Text.xs>
      </div>
      <Copy_row className={cns.link}
        value={get_referral_link(REFERRAL_BASE, code)}/>
      <FAQ_link link={FAQ_LINK_REFERRAL}/>
    </div>;
}

export function Invite_sharer({className}){
    const user = useStore($user);
    const {referral_code, bvpn_ref_enabled, is_root} = user;
    const [{referral_part}] = store.use_money();
    const show_ref = bvpn_ref_enabled||is_root;
    return <div className={cn(cns.root, className)}>
      <Text.m h4 className={cns.title}>Your referral links:</Text.m>
      <div className={cns.body}>
        <Link code={referral_code} part={referral_part}/>
        <Link_bvpn code={referral_code} show_ref={show_ref}/>
      </div>
    </div>;
}
